/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Many/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Many({
  children,
  viewPath = "/App/ChooseLocation/ParentCompanies/Content/Many",
  isSubmitting
  
}) {
let parentCompaniesValueData = fromData.useDataValue({ viewPath,
context: 'parent_companies',
})
let selectedXidValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'xid',
})
let selectedXidIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isSubmitting
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = 'xid:'
let selectedXidValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'xid',
})
let aggregateData = fromAggregate.join(constantData, selectedXidValueData1)
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 id="xid"
 keepValueUnchanged={true}
 data="parent_companies"
 from={parentCompaniesValueData}
 onChange={onChange}
 data="selected.xid"
 value={selectedXidValueData}
 disabled={selectedXidIsSubmittingData}
 maxWidth={240}
 marginRight={dtSpaceXs}
 marginTop={0}
 flexGrow={0}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Parent company"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
 size="normal"
 marginTop={dtSpaceS}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="'xid:'"
 data="selected.xid"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
)}
</TysiaTag>
)}
</SupportOnly>
{children}
</React.Fragment>)
}